import styled from 'styled-components';

export const StyledAddressSection = styled.div`
   display: grid;
   grid-template-columns: 308px 126px 126px;
   grid-template-rows: auto auto;
   grid-gap: 24px 36px;
`;
StyledAddressSection.displayName = 'StyledAddressSection';
